export default __webpack_public_path__ + "static/media/litho-demo-classic-blog.708c52f2.jpg";